import PropTypes from 'prop-types';

import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import LeadComment from './LeadComment';
import CommentEditor from './CommentEditor';

const LeadComments = props => {
  const {lead} = props;
  return (
    <Stack gap={1}>
      <Typography variant='h3'>Comments</Typography>
      <Divider/>
      {
        lead?.comments?.length === 0 &&
        <Typography align='center' variant='body1'>No comments yet</Typography>
      }
      {(lead?.comments || []).map(c => (
        <LeadComment key={c.id} comment={c} />
      ))}
      <CommentEditor lead={lead} />
    </Stack>
  );
};

LeadComments.propTypes = {
  lead: PropTypes.object.isRequired,
};

export default LeadComments;